import React, {Component} from "react";
import FlexView from "react-flexview";
import Button from "../../../modules/commons/Button";
import Container from "../../../modules/commons/Container";
import SimpleButton from "../../../modules/commons/SimpleButton";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import Api from "../../../Services/Api";
import SimpleDDL from "../../../modules/SimpleDDL";
import {formGroup, tableColumns} from "./config";
import SimpleDate from "../../../modules/SimpleDate";
import M from "moment";
import MasterUnitPriceModifying from "./masterUnitPriceModifying";
import MasterUnitPriceFilter from "./masterUnitPriceFilter";
import SimplePrintTable from "../../../modules/popup/SimplePrintTable";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync} from "../../../Services/Utils";
import {HttpStatus} from "../../common/Constants";

class MasterUnitPrice extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                setCellProps: () => ({
                    style: {width: "5%"},
                }),
            },
        },
        ...tableColumns,
        {
            name: "kodeDocument",
            label: "Aksi",
            options: {
                customBodyRender: (id) => {
                    return (
                        <FlexView vAlignContent="center">
                            <Button
                                className="btnAct"
                                onClick={() => this.handleUpdatedata(id)}
                            >
                                <i
                                    className="fa fa-lw fa-pencil-alt"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                            <Button
                                className="btnAct margin-left-15px"
                                onClick={() => this.handleDelete(id)}
                            >
                                <i
                                    className="fa fa-trash"
                                    style={{
                                        backgroundColor: "transparent",
                                        color: "red",
                                        fontSize: 20,
                                    }}
                                />
                            </Button>
                        </FlexView>
                    );
                },
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            formGroup: formGroup,
            tableData: [],
            loading: false,
            isModifyingModalVisible: false,
            isFilterModalVisible: false,
            printModalVisible: false,
            kodeCabang: [],
            filterData: {},
            temporaryFilter: {},
            selectedCabang: {},
            paramFilters: {},
            selectedDocument: "",
            displayActive: true,
            formDisplay: "BARU",
            limit: 5,
            page: 1,
            totalData: 0,
        };
    }

    async componentDidMount() {
        this.handleTriggerLoading();
        const response = await Api.create(
            "NAGAMAS_MASTER_DATA"
        ).findAllMasterCabang();
        if (response.ok) {
            const filteredData = response.data.data
                .filter((item) =>
                    this.props.menuAccess
                        .map((data) => data.idRefObj)
                        .includes(item.kodeCabang)
                )
                .map(({kodeCabang, namaDealer}) => ({
                    label: namaDealer,
                    value: kodeCabang,
                }));
            if (filteredData.length > 0) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    kodeCabang: filteredData,
                    selectedCabang: filteredData[0],
                    filterData: {
                        kodeCabang: [filteredData[0].value],
                        fromDate: M(new Date()).format("DD-MM-YYYY"),
                        toDate: M(new Date()).format("DD-MM-YYYY")
                    },
                    paramFilters: {
                        kodeCabang: [filteredData[0].value],
                        fromDate: M(new Date()).format("DD-MM-YYYY"),
                        toDate: M(new Date()).format("DD-MM-YYYY")
                    },
                }));
            }
        }
        this.handleTriggerLoading();
    }

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        // this.handleTriggerLoading();
        this.setState((prevState) => ({...prevState, totalData: 0, isFetch: true}));
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterUnitPrice,
            menuName: "Master Unit Price",
            setError: this.props.setError,
            args: {
                paramFilters: filter,
                limit,
                page,
            }
        });
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.setState((prevValue) => ({
                ...prevValue,
                tableData: res.data.data,
                totalData: res.data.totalData,
                limit,
                page,
            }));
        }
        this.setState((prevState) => ({...prevState, isFetch: false}));
        // this.handleTriggerLoading();
    };


    componentDidUpdate = async (_, prevState) => {
        if ((prevState.page !== this.state.page ||
                prevState.limit !== this.state.limit) &&
            !this.state.isFetch) {
            this.handleTriggerLoading();
            await this.fetchData(
                this.state.paramFilters,
                this.state.page,
                this.state.limit,
            );
            this.handleTriggerLoading();
        }

        if (prevState.selectedCabang !== this.state.selectedCabang) {
            this.handleTriggerLoading();
            const updatedFilterData = {
                kodeCabang: [this.state.selectedCabang.value],
                fromDate: M(new Date()).format("DD-MM-YYYY"),
                toDate: M(new Date()).format("DD-MM-YYYY"),
            };
            this.setState((prevValue) => ({
                ...prevValue,
                filterData: updatedFilterData,
                paramFilters: updatedFilterData,
                temporaryFilter: {},
            }));
            await this.fetchData(updatedFilterData);
            this.handleTriggerLoading();
        }
    }


    handleDelete = async (id) => {
        await this.setState((prevValue) => ({
            ...prevValue,
            formDisplay: "DELETE",
            displayActive: !prevValue.displayActive,
            selectedDocument: id,
        }));
        this.handleModifyingModalVisibility();
    };

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            page: tableState.page + 1,
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            page: 1,
            totalData: 0,
            limit: tableState.rowsPerPage,
        }));
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
            page: 1,
            limit: 5
        }));
    };

    handleInputDateChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterData: {
                ...prevValue.filterData,
                [name]: M(value).format("DD-MM-YYYY"),
            },
        }));
    };

    handleOnSubmitFilterSearch = async () => {
        this.handleTriggerLoading();
        let updatedFilterData;
        await this.setState((prevValue) => {
            updatedFilterData = {
                ...prevValue.filterData,
                kodeCabang: [this.state.selectedCabang.value],
            };
            return {
                ...prevValue,
                filterData: updatedFilterData,
                paramFilters: updatedFilterData,
                temporaryFilter: {},
            };
        });
        await this.fetchData(updatedFilterData, 1, this.state.limit);
        this.handleTriggerLoading();
    };


    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handleUpdatedata = (id) => {
        this.setState(
            (prevValue) => ({
                ...prevValue,
                formDisplay: "EDIT",
                selectedDocument: id,
            }),
            () => {
                this.handleModifyingModalVisibility();
            }
        );
    };

    handleModifyingModalVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            isModifyingModalVisible: !prevValue.isModifyingModalVisible,
        }));
    };

    handleSubmitData = async (data) => {
        this.handleTriggerLoading();
        if (this.state.displayActive) {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").createMasterUnitPrice,
                menuName: "Master Unit Price",
                setError: this.props.setError,
                args: data,
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.handleModifyingModalVisibility();
                await this.refetch();
                this.handleTriggerLoading();
                return;
            }
        } else {
            let res = await fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").deleteMasterUnitPrice,
                menuName: "Master Unit Price",
                setError: this.props.setError,
                args: this.state.selectedDocument,
            });
            if (res.ok && res.data.status === HttpStatus.SUCCESS) {
                this.handleModifyingModalVisibility();
                await this.refetch();
                this.handleTriggerLoading();
                return;
            }
            this.setState((prevValue) => ({
                ...prevValue,
                displayActive: !prevValue.displayActive,
            }));
        }
        this.setState((prevValue) => ({
            ...prevValue,
            formDisplay: "BARU",
            selectedDocument: "",
        }));
        this.handleTriggerLoading();

    };

    handleFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            isFilterModalVisible: !prevValue.isFilterModalVisible,
        }));
    };

    refetch = async () => {
        await this.fetchData(
            this.state.paramFilters,
            this.state.page,
            this.state.limit,
        );
    };

    handleFilterInput = async (data) => {
        this.handleTriggerLoading();
        this.setState((prevValue) => ({
            ...prevValue,
            temporaryFilter: data,
            paramFilters: data,
            filterData: {},
        }))
        await this.fetchData(data, 1, this.state.limit);

        this.handleFilterVisibility();
        this.handleTriggerLoading();
    };

    handleDisplatActive = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            selectedDocument: "",
            formDisplay: "BARU",
            displayActive: true,
        }));
    };

    handleResetFilter = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            temporaryFilter: {},
            paramFilters: prevValue.filterData,
        }));
    }

    handlePrint = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            printModalVisible: !prevValue.printModalVisible
        }));
    }

    render() {
        return (
            <>
                <Container>
                    <div
                        className="margin-top-5px margin-bottom-20px"
                    >
                        <SimpleDDL
                            id="select_options_nama_cabang"
                            box="search"
                            name="s"
                            containerclassname="width width-250px"
                            placeholder="Nama cabang hak akses"
                            options={this.state.kodeCabang}
                            value={this.state.selectedCabang}
                            onChange={(value) => {
                                this.handleValueChange("selectedCabang", value);
                            }}
                        />
                    </div>
                    <FlexView
                        style={{justifyContent: "space-between", alignItems: "center"}}
                        className="margin-bottom-20px margin-top-5px"
                    >
                        <FlexView vAlignContent="center" style={{gap: "15px"}}>
                            <h3 className="padding-bottom-10px">Periode</h3>
                            <SimpleDate
                                id="select_date_from"
                                date={this.state.filterData?.fromDate}
                                onChange={(value) =>
                                    this.handleInputDateChange("fromDate", value)
                                }
                            />
                            <p className="margin-bottom-20px" style={{textAlign: "center"}}>
                                To
                            </p>
                            <SimpleDate
                                id="select_date_to"
                                date={this.state.filterData?.toDate}
                                onChange={(value) =>
                                    this.handleInputDateChange("toDate", value)
                                }
                            />
                            <SimpleButton
                                className="margin-bottom-15px"
                                text="Cari"
                                onClick={this.handleOnSubmitFilterSearch}
                            />
                        </FlexView>
                        <Button
                            type="button"
                            className="btn background-red margin-bottom-15px"
                            onClick={this.handleFilterVisibility}
                        >
              <span>
                <i className="fa fa-qrcode"></i>
              </span>
                        </Button>
                    </FlexView>
                    <SimpleDataTable
                        data={this.state.tableData}
                        columns={this.tableColumns}
                        toCount={this.state.totalData}
                        rowsPerPage={this.state.limit}
                        page={this.state.page - 1}
                        options={defaultTableChange(
                            this.handleChangePage,
                            this.handleRowsPerPage
                        )}
                        footerAdditionalButtons={
                            <>
                                <SimpleButton
                                    onClick={() => this.handleModifyingModalVisibility()}
                                >
                  <span>
                    <i className="fa fa-plus margin-right-10px"></i>
                  </span>
                                    Tambah
                                </SimpleButton>
                                <SimpleButton secondary onClick={this.handlePrint}>
                                    Cetak
                                </SimpleButton>
                            </>
                        }
                    />
                    <SimpleLoadingOverlay active={this.state.loading}/>
                </Container>
                {this.state.isModifyingModalVisible && (
                    <MasterUnitPriceModifying
                        {...this.props}
                        id={this.state.selectedDocument}
                        visible={this.state.isModifyingModalVisible}
                        onClose={this.handleModifyingModalVisibility}
                        onSubmit={this.handleSubmitData}
                        display={this.state.formDisplay}
                        kodeCabang={this.state.selectedCabang}
                        optionCabang={this.state.kodeCabang}
                        displayActive={this.state.displayActive}
                        handleDisplatActive={this.handleDisplatActive}
                    />
                )}
                {this.state.isFilterModalVisible && (
                    <MasterUnitPriceFilter
                        {...this.props}
                        visible={this.state.isFilterModalVisible}
                        temporaryFilter={this.state.temporaryFilter}
                        onClickClose={this.handleFilterVisibility}
                        onSubmit={this.handleFilterInput}
                        onReset={this.handleResetFilter}
                        kodeCabang={this.state.kodeCabang}
                        selectedCabang={this.state.selectedCabang}
                    />
                )}

                {this.state.printModalVisible && <SimplePrintTable onClearPrint={this.handlePrint}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(MasterUnitPrice);
